export const formatNumber = (num) => {
  // Convert input to a number if it's not already
  const numValue = typeof num === 'number' ? num : Number(num);

  // Check if the conversion resulted in a valid number
  if (isNaN(numValue)) {
    return 'Invalid number';
  }

  if (numValue >= 1000000) {
    return (numValue / 1000000).toFixed(2).replace(/\.?0+$/, '') + "M";
  } else if (numValue >= 1000) {
    return (numValue / 1000).toFixed(2).replace(/\.?0+$/, '') + "K";
  }
  return numValue.toString();
};
